import React from "react";
import { Formik } from "formik";
import * as Yup from "yup";
// import 'typeface-roboto';
import { withStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import { StepButtons } from "../CommonComponents";
import { Consumer } from "./EWCCContext";
import styles from "../ewccstyle";

const TradeReference = withStyles(styles)(function(props) {
  const { activeStep, handleBack, classes } = props;

  return (
    <Consumer>
      {context => (
        <Formik
          initialValues={{
            friendName: context.friendName,
            friendBusiness: context.friendBusiness,
            friendPosition: context.friendPosition,
            friendDept: context.friendDept,
            friendPhone: context.friendPhone
          }}
          validationSchema={Yup.object().shape({
            friendName: Yup.string()
              .required("Personal Reference Name is required")
              .max(200, "Text too long"),
            friendBusiness: Yup.string()
              .required("Company/Business Name is required")
              .max(200, "Text too long"),
            friendPosition: Yup.string()
              .required("Position is required")
              .max(150, "Text too long"),
            friendDept: Yup.string()
              .required("Department is required")
              .max(150, "Text too long"),
            friendPhone: Yup.string()
              .required("Contact No. is required")
              .max(12, "Invalid Phone")
          })}
          onSubmit={(values, actions) => {
            context.updateState("friendName", values.friendName);
            context.updateState("friendBusiness", values.friendBusiness);
            context.updateState("friendPosition", values.friendPosition);
            context.updateState("friendDept", values.friendDept);
            context.updateState("friendPhone", values.friendPhone);
            actions.setSubmitting(false);
            props.handleSubmit();
          }}
        >
          {props => {
            const {
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting
            } = props;
            return (
              <form noValidate autoComplete="off">
                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="friendName"
                    label="Full Name"
                    className={classes.textField}
                    value={values.friendName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    // style={{minWidth: 300}}
                    helperText={
                      errors.friendName && touched.friendName
                        ? errors.friendName
                        : "(First, Middle, Last)"
                    }
                    error={
                      errors.friendName && touched.friendName ? true : false
                    }
                  />
                </FormControl>

                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="friendBusiness"
                    label="Company/Business Name"
                    className={classes.textField}
                    value={values.friendBusiness}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    // style={{minWidth: 300}}
                    helperText={
                      errors.friendBusiness && touched.friendBusiness
                        ? errors.friendBusiness
                        : ""
                    }
                    error={
                      errors.friendBusiness && touched.friendBusiness
                        ? true
                        : false
                    }
                  />
                </FormControl>

                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="friendPosition"
                    label="Position"
                    // placeholder="FIRST NAME"
                    className={classes.textField}
                    value={values.friendPosition}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    // style={{minWidth: 300}}
                    helperText={
                      errors.friendPosition && touched.friendPosition
                        ? errors.friendPosition
                        : ""
                    }
                    error={
                      errors.friendPosition && touched.friendPosition
                        ? true
                        : false
                    }
                  />
                </FormControl>

                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="friendDept"
                    label="Department"
                    // placeholder="FIRST NAME"
                    className={classes.textField}
                    value={values.friendDept}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    // style={{minWidth: 300}}
                    helperText={
                      errors.friendDept && touched.friendDept
                        ? errors.friendDept
                        : ""
                    }
                    error={
                      errors.friendDept && touched.friendDept ? true : false
                    }
                  />
                </FormControl>

                <FormControl fullWidth margin="dense">
                  <TextField
                    required
                    id="friendPhone"
                    label="Contact No."
                    className={classes.textField}
                    value={values.friendPhone}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    // style={{minWidth: 300}}
                    helperText={
                      errors.friendPhone && touched.friendPhone
                        ? errors.friendPhone
                        : " If provincial, include area code"
                    }
                    error={
                      errors.friendPhone && touched.friendPhone ? true : false
                    }
                  />
                </FormControl>

                <StepButtons
                  isSubmitting={isSubmitting}
                  activestep={activeStep}
                  handleBack={handleBack}
                  handleNext={handleSubmit}
                />
              </form>
            );
          }}
        </Formik>
      )}
    </Consumer>
  );
});

export default TradeReference;
